import type { Id } from '~convex/_generated/dataModel'
import type { LibraryScope } from '../upload-store'

/**
 * The Drive browses libraries only. A site visit's photo pool takes uploads
 * through the same store but has no folders, search, or breadcrumbs to
 * render — it is not a `<FilesView />` scope.
 */
export type FilesViewScope = LibraryScope

/** Shape of the search params owned by `<FilesView />`. */
export type FilesViewSearch = {
  folderId?: Id<'fileFolders'>
  view?: 'list' | 'grid'
  q?: string
  sort?: 'name' | 'modified' | 'size' | 'kind'
  dir?: 'asc' | 'desc'
}

export const DEFAULT_SORT = { by: 'name' as const, dir: 'asc' as const }

/** Whitelisted decoder for the URL search shape — drops unknowns silently. */
export const decodeFilesSearch = (search: Record<string, unknown>): FilesViewSearch => {
  const view = search.view === 'grid' ? 'grid' : search.view === 'list' ? 'list' : undefined
  const sort =
    search.sort === 'name' ||
    search.sort === 'modified' ||
    search.sort === 'size' ||
    search.sort === 'kind'
      ? search.sort
      : undefined
  const dir = search.dir === 'desc' ? 'desc' : search.dir === 'asc' ? 'asc' : undefined
  const folderId =
    typeof search.folderId === 'string' ? (search.folderId as Id<'fileFolders'>) : undefined
  const q = typeof search.q === 'string' ? search.q : undefined
  return { dir, folderId, q, sort, view }
}
